
export const DISCLAIMER_INFO_QUERY_KEY = 'disclaimer-info' as const;